import { FC, ReactNode, useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { Wrapper } from "./styled";

interface IScrollableWrapperProps {
  className?: string;
  maxHeight?: number;
  children: ReactNode;
}

export const ScrollableWrapper: FC<IScrollableWrapperProps> = ({
  children,
  className,
  maxHeight = 672,
}) => {
  const [height, setHeight] = useState(0);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setHeight(ref?.current?.clientHeight ?? 0);
  }, [ref]);

  return (
    <Wrapper
      className={classNames(className, "scrollable-wrapper", {
        withScroll: height > maxHeight,
      })}
      data-testid="scrollable-wrapper"
      ref={ref}
      $withOverflow={height > maxHeight}
      $maxHeight={maxHeight}
    >
      {children}
    </Wrapper>
  );
};
